import clsx from 'clsx';
import React from 'react';

import IconDeepResearchText from '@components/Images/DeepResearch/IconDeepResearchText';
import IconArrow from '@components/Images/IconArrow';
import LazyImgixImage from '@components/LazyImgixImage';
import { useEventTracking } from '@hooks/index';
import { deep_research_path } from '@routes';
import { ClickTarget, click } from '@tracking';

import { DEEP_RESEARCH_IMG_LINK } from './constants';

export interface DeepResearchPromoProps {
  className?: string;
  isMobile?: boolean;
}

const DeepResearchPromo = ({ className = '', isMobile = false }: DeepResearchPromoProps) => {
  const { trackEvent } = useEventTracking();

  return (
    <div className={className}>
      <div className={clsx('flex', isMobile ? 'justify-center' : 'justify-center')}>
        <LazyImgixImage
          src={DEEP_RESEARCH_IMG_LINK}
          alt="Deep Research"
          className="w-full"
          wrapperClassName={isMobile ? 'w-[240px]' : 'w-[350px]'}
        />
      </div>
      <p
        className={clsx(
          'mb-8 mt-24 font-suisse-works md:mt-32',
          isMobile ? 'text-left text-headline-xxs' : 'text-center text-headline-sm'
        )}
      >
        The pace of AI, the precision of our newsroom.
      </p>
      <div className="flex items-center justify-start gap-8 md:justify-center">
        <span
          className={clsx('font-suisse-works', isMobile ? 'text-overline-lg' : 'text-headline-sm')}
        >
          Ask
        </span>
        <a
          href={deep_research_path()}
          className="group"
          onClickCapture={() =>
            trackEvent(
              click({ clickTarget: ClickTarget.DeepResearchIcon, clickText: 'Ask Deep Research' })
            )
          }
          aria-label="onboarding final step deep research link"
        >
          <IconDeepResearchText
            className={clsx('self-start', isMobile ? 'w-[160px]' : 'w-[250px]')}
          />
          <IconArrow
            className={clsx(
              'relative ml-12 rotate-180 text-primary-magenta',
              isMobile ? 'h-[15px]' : 'h-[30px]'
            )}
          />
        </a>
      </div>
    </div>
  );
};

export default DeepResearchPromo;
